module.exports = __webpack_public_path__ + "img/budget_icon.a386c328.svg";